import { Component, OnInit } from '@angular/core';
import { ScheduleService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';





@Component({
  selector: 'app-assessmentsch',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.scss'],
  providers:[ScheduleService,MasterService]
 
})
export class AssessmentschComponent implements OnInit {
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  
   data = [
     {
       id: 1,
       name: 'Usa'
     },
     {
       id: 2,
       name: 'England'
     }
  ];

  selclid: number = 0;
    mascls: any = [];
    massub: any = [];
    masass: any = [];
    masasstype: any = [];
    objfilt:any={};
    objsch:any={};
    arrasch:any=[];
    arrbatch:any=[];
    completeDate: Date;
localCompleteDate: string;

  constructor(private http: HttpClient, private sservice: ScheduleService,private mservice:MasterService,private modalService: NgbModal) { 

    this.completeDate = new Date();
    this.localCompleteDate = this.completeDate.toISOString();
    this.localCompleteDate = this.localCompleteDate.substring(0, 16);
  }
  
  open(content) {
    this.modalOptions = {
     
      size:'md'
     
    }
    this.modalService.open(content, this.modalOptions ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
 
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {

    this.Getsel_sp_massubjects();
    this.Getclasslist();
    this.Getsel_sp_masasshead();
    this.Getsel_sp_masasstype();
    this.selbatch();
    this.Bindtable();
  }

  Getclasslist() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('class-result', resultArray);
            this.mascls = resultArray;
            this.objfilt.clid=resultArray[0].clid;
        },
        error => console.log("Error :: " + error)
        )
}

Getsel_sp_masasshead()
{
  debugger
  this.mservice.sel_sp_masasshead()
  .subscribe(
  resultArray =>{
    //console.log('sub-result', resultArray);
  this.masass=resultArray;
  this.objfilt.asid=resultArray[0].asid;
    },
error => console.log("Error :: " + error)
)
}

selbatch()
{
  debugger
  this.mservice.selbatch()
  .subscribe(
  resultArray =>{
    //console.log('sub-result', resultArray);
    this.arrbatch=resultArray;
    this.objfilt.baid=resultArray[0].baid;
    },
error => console.log("Error :: " + error)
)
}
Getsel_sp_masasstype()
{
  debugger
  this.mservice.sel_sp_masasstype()
  .subscribe(
  resultArray =>{
    //console.log('sub-result', resultArray);
    this.masasstype=resultArray;
    this.objfilt.astypeid=resultArray[0].astpid;
    },
error => console.log("Error :: " + error)
)
}
Getsel_sp_massubjects() {
    this.mservice.sel_sp_massubjects()
        .subscribe(
        resultArray => {
            
            this.massub = resultArray;
           
        },
        error => console.log("Error :: " + error))
}


Bindtable() {
  debugger
  var clid = this.objfilt.clid;
  var assid = this.objfilt.asid;
  var asstypeid = this.objfilt.astypeid;
  var baid = this.objfilt.baid;
 
  //var clssubdata = { clid: clid,assid:assid,asstypeid:asstypeid,clcd:clcd,aycd:aycd};
  //console.log('model', clssubdata);
  this.sservice.sel_sp_schasssch(clid,assid,asstypeid,baid)
      .subscribe(resultArray => {
         console.log('arrasch', resultArray);
          this.arrasch = resultArray;
          //alert (resultArray.message);

      }, error =>
          alert('error in connection')
      );
  //this.closeAddExpenseModal.nativeElement.click();
}


opensubject(content,objdata,cmd) {
  debugger
  if(cmd=='insert')
  {
    this.objsch={};
   
    
    console.log('date',this.sservice.getdatetoday().toString())
    this.objsch.suid=0;
    this.objsch.subgpId=0;
    this.objsch.asdt= this.localCompleteDate;
    this.objsch.portion='';
    this.objsch.rmk='';
    this.objsch.astmfm='';
    this.objsch.astmto='';
    //this.objsubject.subcaId=0;
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objsch.oprtype='insert';
   
  }

  else if(cmd=='update')
  {
    this.objsch=objdata;
    this.objsch.oprtype='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


SaveDetails() {
  var clid = this.objsch.clid;
  var subid = this.objsch.suid;
  var assid = this.objsch.asid;
  var asstypeid = this.objsch.astpid;
  var assdt = this.objsch.asdt;
  var portion = this.objsch.portion;
  var remarks = this.objsch.rmk;
  var baid = this.objsch.baid;
  var from = this.objsch.astmfm;
  var to = this.objsch.astmto;

  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
 // var oprtag = "insert"
  var clssubdata = {astmfm:from,astmto:to, clid: clid, suid: subid, oprtag: this.objsch.oprtype,asid:assid,astpid:asstypeid,portion:portion,rmk:remarks,asdt:assdt,clcd:clcd,aycd:aycd,baid:baid };
  
  
 
  console.log('save-model', clssubdata);
  this.sservice.save_sp_schasssch(clssubdata)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
           // this.Getsel_sp_massubgp();
           this.Bindtable();
          }
          

      }, error =>
          alert('error in connection')
      );
 // this.closeAddExpenseModal.nativeElement.click();
}



deletesch(item) {

if(confirm("Are you sure ? you wan't to delete"))
{
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
 // var oprtag = "insert"
  //var clssubdata = { clid: clid, suid: subid, oprtag: this.objsch.oprtype,asid:assid,astpid:asstypeid,portion:portion,rmk:remarks,asdt:assdt,clcd:clcd,aycd:aycd,baid:baid };
  
  item.oprtag="delete";
  item.clcd=clcd;
  item.aycd=aycd;
 
  //console.log('save-model', clssubdata);
  this.sservice.save_sp_schasssch(item)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
           // this.Getsel_sp_massubgp();
           this.Bindtable();
          }
          

      }, error =>
          alert('error in connection')
      );
 // this.closeAddExpenseModal.nativeElement.click();
}
}
}
